import { axiosInstance } from './axiosInstance';

const serializeParams = (params = {}) => {
	const search = new URLSearchParams();

	Object.entries(params).forEach(([key, value]) => {
		if (value === '' || value === null || value === undefined) {
			return;
		}

		if (Array.isArray(value)) {
			const arrayKey = key.endsWith('[]') ? key : `${key}[]`;
			value.forEach((item) => {
				if (item !== '' && item !== null && item !== undefined) {
					search.append(arrayKey, item);
				}
			});
			return;
		}

		search.append(key, value);
	});

	return search.toString();
};

export const ToolLeadServices = {
	getConfig: async () => {
		return await axiosInstance.get('/api/feature/tool-lead/config');
	},
	getAll: async (filter) => {
		return await axiosInstance.get('/api/feature/tool-lead/admin', {
			params: filter,
			paramsSerializer: serializeParams,
		});
	},
	export: async (filter) => {
		return await axiosInstance.get('/api/feature/tool-lead/admin/export', {
			params: filter,
			paramsSerializer: serializeParams,
			responseType: 'blob',
		});
	},
	delete: async (id) => {
		return await axiosInstance.delete(`/api/feature/tool-lead/admin/${id}`);
	},
};
